import React, { useEffect, useState } from "react";
import { getDomainConfig } from "../../config/config";

const StandardLabel = (props) => {

const config = getDomainConfig();

/* LOADING THE BRANDED SCSS */
const [styles, setStyles] = useState(false);

useEffect(() => {

const getStyles = async (theFileName, theFileEnd) => {
  if (config.brand) {
    let moduleStyles = false;
    try {
      moduleStyles = await import(
        "./" + theFileName + config.brand + theFileEnd
      );
      setStyles(moduleStyles);
    } catch (e) {
      console.error(
        `Styles for ${theFileName} could not be loaded, ${e.message}`
      );
    }
  }
};

  // Specify file name and end of file name here.
  getStyles("StandardLabel", ".module.scss");
}, [config.brand]);

/* END LOADING THE BRANDED SCSS */


  const propsId = props.id; // The id that may have come through from props
  let requiredLabel = ''; // Might have a required label come through from props
  let defaultClass = styles.inputLabel; // The generic class (in css modules format)
  let disabledClass = styles.disabled;
  let selectedClass = styles.selected;
  let classes = defaultClass; // The classes list to show

  if (props.className) { // If any extra classes come through via props, turn them into css modules format too
    classes = classes + ' ' + props.className.split(' ').map(thisStyle => {
      return styles[thisStyle];
    }).join(' ');
  }

  if (props.disabled) { // If this has a disabled prop, add the disabled class
    classes = classes + " " + disabledClass;
  }

  if (props.selected) { // If this has a selected prop, add the selected class
    classes = classes + " " + selectedClass;
  }

  if (props.required) {
    requiredLabel = <span className={styles.required} title="Required">*</span>;
 }

  return (
    <label className={classes} id={propsId} htmlFor={props.htmlFor}>
      {props.children}
      {requiredLabel}
    </label>
  );
};

export default StandardLabel;
